// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"48644fb4","186":"5d6bf243","253":"0f7b85b7","277":"0a347f2f","322":"17c5f222","348":"6a4ca4f5","385":"5762685f","599":"c91a3a2d","617":"11a16566","637":"9230a821"}[chunkId] + ".chunk.js";
};